import { FaWhatsapp } from 'react-icons/fa'
import { IoIosCall } from 'react-icons/io'
import { IoLogoFacebook, IoLogoInstagram } from 'react-icons/io5'

export default function Footer() {
  const socialLinks = [
    {
      icon: IoIosCall,
      href: "tel:+972509933553",
      label: "התקשרו אלי",
      color: "from-card to-card",
      hoverColor: "hover:from-primary hover:to-card"
    },
    {
      icon: FaWhatsapp,
      href: "https://wa.me/972509933553",
      label: "WhatsApp",
      color: "from-card to-card",
      hoverColor: "hover:from-primary hover:to-card"
    },
    {
      icon: IoLogoInstagram,
      href: "https://www.instagram.com/mali.dayan.relationship",
      label: "Instagram",
      color: "from-card to-card",
      hoverColor: "hover:from-primary hover:to-card"
    },
    {
      icon: IoLogoFacebook,
      href: "https://www.facebook.com/profile.php?id=100085450906939",
      label: "Facebook",
      color: "from-card to-card",
      hoverColor: "hover:from-primary hover:to-card"
    }
  ]

  return (
    <footer id="footer" className="relative dotbg py-16" dir="rtl">
 

      <div className="relative bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl max-w-[900px] mx-auto overflow-hidden border border-primary/20">
        <div className="px-8 py-12">
          
          {/* Header Section */}
          <div className="text-center mb-12" data-aos="fade-up" data-aos-delay="100">
            <h2 className="text-4xl md:text-5xl font-bold gradient-text-animated mb-4">
              מלי דיין
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
              יועצת זוגית ומשפחתית 
            </p>
            <div className="w-24 h-1 bg-gradient-to-r from-primary to-secondary rounded-full mx-auto mt-4"></div>
          </div>

          {/* Contact CTA Section */}
          <div className="text-center mb-12 py-8 bg-gradient-to-r from-primary/5 to-secondary/5 rounded-2xl" data-aos="fade-up" data-aos-delay="200">
            <h3 className="text-2xl md:text-3xl font-bold text-primary mb-4">
              מוכנים לשינוי חיובי?
            </h3>
            <p className="text-lg text-gray-600 mb-8 max-w-xl mx-auto">
              בואו נתחיל במסע משותף לחיים מאושרים יותר
            </p>
            
            {/* Main Action Buttons - Navbar Style */}
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8">
              <a
                href="https://wa.me/972509933553"
                className="group flex items-center justify-center space-x-2 space-x-reverse px-6 py-3 rounded-xl bg-card hover:bg-primary text-white font-semibold transition-all duration-300 ease-out transform hover:scale-105 hover:-translate-y-1 shadow-lg hover:shadow-xl relative overflow-hidden"
              >
                <span className="relative z-10">שלחו הודעה</span>
                <FaWhatsapp className="text-lg relative z-10 group-hover:animate-bounce" />
              </a>
              
              <a
                href="tel:+972509933553"
                className="group flex items-center justify-center space-x-2 space-x-reverse px-6 py-3 rounded-xl bg-primary text-white font-semibold transition-all duration-300 ease-out transform hover:scale-105 hover:-translate-y-1 shadow-lg hover:shadow-xl relative overflow-hidden"
              >
                <span className="relative z-10">התקשרו עכשיו</span>
                <IoIosCall className="text-lg relative z-10 group-hover:animate-pulse" />
              </a>
            </div>
          </div>

          {/* Social Media Links - Navbar Style */}
          <div className="text-center mb-8" data-aos="fade-up" data-aos-delay="300">
            <h4 className="text-lg font-semibold text-primary mb-6">עקבו אחרי ברשתות החברתיות</h4>
            <div className="flex justify-center gap-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon
                return (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`group flex items-center justify-center w-12 h-12 bg-card ${social.color} ${social.hoverColor} rounded-xl transition-all duration-300 ease-out transform hover:scale-110 hover:-translate-y-1 shadow-md hover:shadow-lg relative overflow-hidden`}
                    title={social.label}
                    style={{
                      animationDelay: `${index * 0.1}s`
                    }}
                  >
                    <Icon className="text-white text-xl relative z-10 group-hover:scale-110 transition-transform duration-300" />
                    
                  </a>
                )
              })}
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="border-t border-primary/20 pt-6 text-center" data-aos="fade-up" data-aos-delay="400">
            <p className="text-gray-500 flex items-center justify-center space-x-2 space-x-reverse">
              <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
              <span>© {new Date().getFullYear()} מלי דיין - כל הזכויות שמורות</span>
            </p>
          </div>

          {/* Made by Section */}
          <div className="mt-6 text-center" data-aos="fade-up" data-aos-delay="500">
            <div dir="ltr" className="flex justify-center">
              <a
                className="group/button relative inline-flex items-center justify-center px-6 py-2 text-sm font-medium overflow-hidden transition-all duration-300 bg-black/20 hover:bg-black/40 rounded-2xl border border-[#ACAEB1]/10"
                href="https://idanshlomo.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="relative z-10 flex items-center">
                  <span className="text-xs font-medium text-black mr-2">Made by</span>
                  <img
                    className="mr-2 group-hover/button:rotate-12 transition-transform duration-300"
                    src="/is-logo.svg"
                    alt="Idan Shlomo Logo"
                    width={25}
                    height={25}
                  />
                  <span className="font-medium text-sm text-black">
                    Idan Shlomo
                  </span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

 
    </footer>
  )
}
